import { ReviewEntryRepository } from '@/domain/repositories/review/reviewEntryRepository'

export class PostEvaluationReviewUseCase {
  constructor(private reviewEntryRepository: ReviewEntryRepository) {}

  async postEvaluationReview(reviewId: string, score: number): Promise<void> {
    try {
      await this.reviewEntryRepository.postEvaluationReview(reviewId, score)
    } catch (error) {
      console.error(`Error in PostEvaluationReviewUseCase: ${error instanceof Error ? error.message : String(error)}`)
      throw error
    }
  }
}
